<script>
export default {
	name: "Header",
	data() {
		return {
			isActiveMenu: false,
		};
	},
	computed: {
		hostUrl() {
			return this.$store.state.hostUrl;
		},
		next_miniUrl() {
			return process.env.VUE_APP_next_miniUrl;
		},
		saleUrl() {
			return process.env.VUE_APP_saleUrl;
		},
	},
};
</script>

<template src="./template.pug" lang="pug"></template>
<style src="./style.sass" lang="sass" scoped>
@use "@/assets/sass/_variable.sass"
@use "@/assets/sass/_mixin.sass"
</style>
